<template>
   
<div class="conteslider bv-example-cambio">
      <b-row>
        <b-col cols="9" class="camnio">
          <b-img class="logoocs" :src="logo"></b-img>
        <b-card style="max-width: 47rem; " class="mb-22 ccs">
            <b-row style="margin: -2.2%;">
                <b-col class="datosuno">
                <div class="contenidosdatos">
                    <b-card-title>
                        <div class="ingreso-al-sistema-prmm poppins-semi-bold-mine-shaft-20px">{{prmCielum}}</div>
                     </b-card-title>
                        <div class="correo-electrnico poppins-semi-bold-tuatara-14px">{{passworde}}</div>
                        <b-input-group>
                            <b-form-input trim @input="validacionCodiciones()" :type="passwordz" v-model="newpassword" class="campo tm emailll" placeholder="******" ></b-form-input>
                            <b-input-group-append class="campoa   eye">
                                <b-input-group-text @click="visualizarpass()">
                                    <b-icon class="eyes" v-if="passwordz == 'password' " icon="eye" />
                                    <b-icon class="eyes" v-if="passwordz == 'text' " icon="eye-slash" />
                                </b-input-group-text>
                            </b-input-group-append>
                        </b-input-group>
                        <div class="correo-electrnico poppins-semi-bold-tuatara-14px">{{confirpasswordd}}</div>
                        <b-input-group>
                            <b-form-input trim @input="validacionContrasena()" v-model="confirpassword" :type="passwordd" class="campo tm emailll" placeholder="******"  :style=" (this.notifi == true  ) ? 'border-top: 2px solid red !important; border-left: 2px solid red !important ; border-bottom: 2px solid red !important' : 'border: 2px solid #ced4da ' " ></b-form-input>
                            <b-input-group-append class="campoa  eye">
                            
                                <b-input-group-text  :style=" (this.notifi == true  ) ? 'border-top: 2px solid red !important; border-right: 2px solid red !important ; border-bottom: 2px solid red !important'  : 'border: 2px solid #ced4da ' " @click="visualizarpasss()">
                                    <b-icon class="eyes" v-if="passwordd == 'password' " icon="eye" />
                                    <b-icon class="eyes" v-if="passwordd == 'text' " icon="eye-slash" />
                                </b-input-group-text>
                            </b-input-group-append>
                        </b-input-group>
                        <div v-if="this.notifi == true " class="ingrese-un-correo-electrnico poppins-normal-alizarin-crimson-12px">{{ nocoinciden }}</div>
                        <div v-if="this.notifi2 == true " class="ingrese-un-correo-electrnico poppins-normal-alizarin-crimson-12px">{{ nocondiciones }}</div>
                        <input class="form-check-input" type="checkbox" v-model="acepto" value="true"
      unchecked-value="false" name="checkbox-1" >
                                 <div class="recordarr poppins-normal-tuatara-14px">Acepto <a  target="_blank" :href="politicas">Políticas de privacidad.</a></div>
                        <div  @click="cambiarPassword()">
                            <b-button block class="boton-ingresoo"  ><span v-if="this.load == false"  class="ingresar poppins-semi-bold-white-14px">Enviar</span><div v-if="this.load == true"><b-spinner small></b-spinner><span class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span></div></b-button></div>
                </div>
                </b-col>
                <b-col >
                    <div class="contenidosdatosdos poppins-normal-tuatara-14px">
                    <p>{{laContraseaDebeC}}</p>
                    <div class="conetnidodes">
                             <div class="chequeo">
                                <input class="form-check-input" type="checkbox" :checked="mini" onclick="return false;"  name="checkbox-1" >
                                 <div class="recordarr poppins-normal-tuatara-14px">{{carateresocho}}</div>
                            </div>
                            <div class="chequeo">
                                <input class="form-check-input" type="checkbox" :checked="datomayus" onclick="return false;"  name="checkbox-1 ">
                                 <div class="recordarr poppins-normal-tuatara-14px">{{caratermayus}}</div>
                            </div>
                            <div class="chequeo">
                                <input class="form-check-input" type="checkbox" :checked="datominus" onclick="return false;"  name="checkbox-1" >
                                 <div class="recordarr poppins-normal-tuatara-14px">{{caraterminus}}</div>
                            </div>
                            <div class="chequeo">
                                <input class="form-check-input" type="checkbox" :checked="datocarater" onclick="return false;"  name="checkbox-1" >
                                 <div class="recordarr poppins-normal-tuatara-14px">{{caraterespecial}}</div>
    
                            </div>
                        <div v-if="this.condiaceptoacepto == true" class="ingrese-una-contraseasg poppins-normal-white-12px">Acepta las Políticas de privacidad para continuar </div>
                        </div>
                  
                    </div>
                </b-col>
            </b-row>
        </b-card>
        </b-col>
        <!-- <b-col><Carousel /> </b-col> -->
    </b-row>
      <div>
        <b-modal
          centered
          hide-footer
          no-close-on-backdrop
          no-close-on-esc
          hide-header
          v-model="isPopup"
          title="Mensaje Exito"
        >
          <img style="height: 50px; margin: 20px" src="/img/Grupo 7275 LOGO CIELUM.svg" />
          <ModalInicio />
        </b-modal>
      </div>
    </div>
  </template>
  
    <script>
  import ModalInicio from "../components/ModalInicio.vue";
  // import Carousel from '../components/Carousel.vue'
  import CambioContrasea from '../views/CambioContrasea.vue'
  import { RepositoryFactory } from "../repositories/RepositoryFactory";
  const password = RepositoryFactory.get("recoverpass");
  const login = RepositoryFactory.get("login");
//   import { Popper } from "popper-vue";
//   import "popper-vue/dist/popper-vue.css";
  
  export default {
    name: "CreacionContrasenaSlide",
    components: {
      ModalInicio,
      // Carousel,
      CambioContrasea,
    },
    props: [
    "logo",
        "prmCielum",
        "passworde",
        "confirpasswordd",
        "children",
        "intentosContra",
        "laContraseaDebeC",
          "carateresocho",
        "caratermayus",
        "caraterminus",
        "caraterespecial",
        "nocondiciones",
        "nocoinciden",
    ],
  
    data() {
      return {
        newpassword: "",
        load:false,
            confirpassword: "",
            notifi: false,
            notifi2: false,
            mini: false,
            mayus: "",
            minus: "",
            datomayus: false,
            datominus: false,
            carater: "",
            datocarater: false,
            passwordz: "password",
            passwordd: "password",
            token: "",
            tokenu: "",
            tokend: "",
            acepto:false,
            condiaceptoacepto:false,
            politicas:" https://cielum.co/privacidad/",
            contraserepetida:false,
      };
    },
  
    async created() {
      this.condiaceptoacepto= false
        const url = window.location.search;
        this.token = url.replace("?token=", "")
        var vt= /%24/g;
        this.tokenu = this.token.replace(vt, "$")
        var vtu = /%2F/g;
        this.tokend = this.tokenu.replace(vtu, "/")
       
        const response = await login.validateToken({
            "token": this.tokend,
        }).catch(async (error) => {
            // this.$router.push('/401');
            this.$router.push({ name: '401', params: { token: this.tokend } });
        });
      
        
    },
    methods: {
    
        async validacionContrasena() {
            if (this.newpassword != this.confirpassword) {
                this.notifi = true;
            } else {
                this.notifi = false;
            }
        },
        async cambiarPassword() {
            if (this.newpassword != this.confirpassword) {
                this.notifi = true;
            } else {
                this.notifi = false;
                if (this.newpassword == "" || this.confirpassword == "" || this.datocarater == false || this.datominus == false || this.datomayus == false || this.mini == false) {
                    this.notifi2 = true;
                    setTimeout(() => {
                        this.$router.go('/CambioContrasea');
                    }, 4000);

                } else {
                    this.notifi2 = false;
                    if(this.acepto== false){
                        this.condiaceptoacepto = true
                    }else{
                    
                      this.load=true;
                      const response = await password.cambioPassword({
                        "password": this.newpassword,
                        "token": this.tokend
                    }).then((respuesta) => {
                    
                        this.$router.push({ name: 'Modal', params: { message: "La contraseña ha sido cambiada exitosamente.", massageboton:"ir al inicio de sesión",actions:"/", } });
                        this.isPopup = true;
                        
                    }).catch((error) => {
                    if(error.response.data.error.code == "TE400"){
                        // this.contraserepetida = true
                    }
                   
                    });
                    }
                    
                }



            }

        },
        async validacionCodiciones() {
            this.mayus = /[A-Z]/;
            this.datomayus = this.mayus.test(this.newpassword);
            this.minus = /[a-z]/;
            this.datominus = this.minus.test(this.newpassword);
            this.carater = /[;:\.,!¡\?¿@#\$%\^&\-_+=/>*<"\(\)\[\]\{\}]/;
            
            this.datocarater = this.carater.test(this.newpassword);
            if (this.newpassword.length >= 8) {
                this.mini = true;
                if (this.datomayus == true || this.datominus == true || this.datocarater == true) {


                } else {
                    this.datocarater = false;
                    this.datominus = false;
                    this.datomayus = false;


                }
            } else {
                this.mini = false;
            }
        },
        async validacion() {
            if (this.newpassword == "" || this.confirpassword == "" || this.datocarater == false || this.datominus == false || this.datomayus == false || this.mini == false) {
                this.notifi2 = true;
                setTimeout(() => {
                    this.$router.go('/CambioContrasea');
                }, 4000);

            } else {
                this.notifi2 = false;
            }
        },
        async visualizarpass() {
            if (this.passwordz == "password") {
                this.passwordz = "text";
            } else {
                this.passwordz = "password";
            }
        },
        async visualizarpasss() {
            if (this.passwordd == "password") {
                this.passwordd = "text";
            } else {
                this.passwordd = "password";
            }
        }

    }
};
</script>
    
    <style>
    .form-check-input{
      margin-top: 0.14em !important;
    border: 1px solid !important;
    border-color: var(--hawkes-blue) !important;
    border-radius: 4px !important;
    width: 20px !important;
    height: 19px !important;
    margin-right:3%;
    cursor: pointer;
    float: left;
}
    .conetnidodes{
      margin-top: 10%;
    }
    .logoocs{
      margin-top: 5%;
    }
    .ccs{
      margin-left: 19%;
    margin-top: 7%;
    }
 .conteslider{
    margin:0;
    max-width: 100% !important;
    height: 755px !important;
}
.camnio{
  background: var(--blue-violet);
  height: 755px ;
  text-align: center;
}

  .contenidosdatos {
    margin: 10%;
  }
  .enviar {
    color: var(--white);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-m);
    font-weight: 600;
    letter-spacing: 0;
    line-height: 14px;
    min-height: 22px;
    text-align: center;
    width: 242px;
  }
  
  .img-fluid {
    max-width: 100% !important;
  }
  
  .rectngulo-1398 {
    background-color: var(--white);
    border-radius: 16px;
    height: 32px;
    left: 220px;
    position: absolute;
    top: 4px;
    width: 86px;
  }
  
  .grupo-9474 {
    align-items: flex-start;
    background-color: var(--white);
    border-radius: 20px;
    display: flex;
    justify-content: flex-end;
    min-width: 40px;
    padding: 13.5px 11.4px;
  }
  
  .siempre-estamos-pres {
    color: var(--white);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-l);
  }
  
  .title {
    color: var(--white);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-xl);
    font-weight: 600;
    left: 24px;
    letter-spacing: 0;
    line-height: 43px;
    position: absolute;
    text-align: center;
    top: 36px;
    width: 500px;
  }
  .grupo-9485 {
    display: flex;
    height: 40px;
    justify-content: space-between;
    left: 0;
    position: absolute;
    top: 0;
    width: 525px;
  }
  
  .grupo-9474 {
    align-items: flex-start;
    background-color: var(--white);
    border-radius: 20px;
    display: flex;
    justify-content: flex-end;
    min-width: 40px;
    padding: 13.5px 11.4px;
  }
  
  .trazado-6180 {
    height: 13px;
    object-fit: cover;
    width: 15px;
  }
  
  .grupo-9475 {
    align-items: flex-start;
    background-color: var(--white);
    border-radius: 20px;
    display: flex;
    min-width: 40px;
    padding: 13.5px 11.4px;
  }
  .grupo-9486 {
    align-items: flex-start;
    display: flex;
    gap: 10px;
    height: 14px;
    left: 232px;
    min-width: 62px;
    position: absolute;
    top: 13px;
  }
  
  .elipse-217 {
    background-color: var(--blue-violet);
    border-radius: 7px;
    height: 14px;
    width: 14px;
  }
  
  .elipse-21 {
    background-color: var(--hawkes-blue);
    border-radius: 7px;
    height: 14px;
    width: 14px;
  }
  .custom-size-22-pantalla-bienvenida-con-slide-11 {
    align-items: flex-start;
    background-color: var(--blue-violet);
    display: flex;
    gap: 67px;
    height: 784px;
    overflow: hidden;
    width: 1536px;
  }
  
  .overlap-group2 {
    height: 992px;
    margin-left: -118px;
    margin-top: -104px;
    position: relative;
    width: 1036px;
  }
  
  .elipse-221 {
    border-radius: 496px;
    height: 992px;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: 992px;
  }
  
  .overlap-group1 {
    height: 960px;
    position: relative;
    width: 628px;
  }
  
  .title {
    color: var(--white);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-xl);
    font-weight: 600;
    left: 24px;
    letter-spacing: 0;
    line-height: 43px;
    position: absolute;
    text-align: center;
    top: 36px;
    width: 500px;
  }
  
  .siempre-estamos-pres {
    color: var(--white);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-l);
    font-weight: 400;
    left: 27px;
    letter-spacing: 0;
    line-height: 20px;
    position: absolute;
    text-align: center;
    top: 196px;
    width: 500px;
  }
  
  .grupo-9518 {
    background-position: 50% 50%;
    background-size: cover;
    height: 619px;
    left: 60px;
    position: absolute;
    top: 341px;
    width: 568px;
  }
  
  .grupo-9512 {
    align-items: flex-end;
    background-position: 50% 50%;
    background-size: cover;
    display: flex;
    height: 201px;
    left: 0;
    min-width: 551px;
    padding: 36.8px 11px;
    position: absolute;
    top: 583px;
  }
  
  .grupo-9499 {
    align-items: flex-start;
    display: flex;
    min-width: 525px;
  }
  
  .overlap-group {
    height: 40px;
    position: relative;
    width: 525px;
  }
  
  .rectngulo-1398 {
    background-color: var(--white);
    border-radius: 16px;
    height: 32px;
    left: 220px;
    position: absolute;
    top: 4px;
    width: 86px;
  }
  .custom-size-22-pantalla-bienvenida-con-slide {
    align-items: flex-start;
    background-color: var(--blue-violet);
    display: flex;
    gap: 60px;
    overflow: hidden;
    width: 1536px;
  }
  
  .component-37-39 {
    height: 136px;
    left: 20px;
    object-fit: cover;
    position: absolute;
    top: 191px;
    width: 196px;
  }
  
  .title {
    left: 30px;
    letter-spacing: 0;
    line-height: 43px;
    position: absolute;
    text-align: center;
    top: 56px;
    width: 500px;
  }
  
  .lorem-ipsum-dolor-si {
    left: 30px;
    letter-spacing: 0;
    line-height: 24px;
    position: absolute;
    text-align: center;
    top: 581px;
    width: 500px;
  }
  /* .form-control:focus {
    color: #212529;
    background-color: #fff;
    border-color: #e61717 !important;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgb(253 13 13 / 25%) !important;
    border-width: 1px !important;
    border-radius: 5px !important;
  } */
  /* .form-control {
    border-radius: 5px !important;
  } */
  
  .carousel-control-prev .sr-only {
    display: none !important;
  }
  .carousel-control-next .sr-only {
    display: none !important;
  }
  .modal {
    background-color: rgb(84, 96, 181, 1);
  }
  .crear-contrasea {
    align-self: flex-end;
    color: #333333;
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-l);
    font-weight: 600;
    letter-spacing: 0;
    line-height: 20px;
    min-height: 30px;
    text-align: center;
    width: 282px;
  }
  .title {
    color: var(--white);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-xl);
    font-weight: 600;
    left: 24px;
    letter-spacing: 0;
    line-height: 43px;
    position: absolute;
    text-align: center;
    top: 36px;
    width: 500px;
  }
  .Titulo {
    color: var(--white);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-xl);
    font-weight: 600;
    /* left: 24px; */
    letter-spacing: 0;
    line-height: 43px;
    /* position: absolute; */
    text-align: center;
    /* top: 36px; */
    /* width: 500px; */
  }
  @media (max-height: 654px) {
    .imagen_slide img {
      height: 350px;
      object-fit: cover;
      object-position: bottom;
    }
  }
  @media (min-height: 655px) {
    .imagen_slide img {
      height: 507px;
      object-fit: cover;
      object-position: bottom;
    }
  }
  @media (max-width: 1370px) {
    .logoocs {
    margin-top: 3%;
    width: 23%;
}
.mb-22 {
    margin-left: 19%;
    margin-top: 5%;
    max-width: 39rem !important;
}

}
  
  /* .carousel-control-prev{
    display: grid !important;
      align-items: end !important;
  }
  .carousel-control-prev-icon{
    filter:drop-shadow("2px 4px 6px black");
      border-radius: 50px;
      margin-bottom: 35px;
      /*color: blue !important;*/
  /*background-image: url(img/izquierdo.png);*/
  /*background-size: 21px;
  }
  .carousel-control-next{
    display: grid !important;
      align-items: end !important;
  }
  .carousel-control-next-icon{
    /*background-color: white;
    filter:drop-shadow("2px 4px 6px black");
      border-radius: 50px;
      margin-bottom: 35px;
      /*color: blue !important;*/
  /*background-image: url(img/izquierdo.png);*/
  /*background-size: 21px;
  } */
  </style>
  